import ROUTERS_PATHS from "consts/router-paths";
import Icons from "consts/svgIcons";

const MenuItems = [
  {
    path: ROUTERS_PATHS.ADMIN_DASHBOARD,
    subPath: [
      ROUTERS_PATHS.CREATE_TOPIC,
      ROUTERS_PATHS.CREATE_CATEGORY,
      ROUTERS_PATHS.CREATE_SUBCATEGORY,
    ],
    label: "Topics",
    Icon: Icons.TopicIcon,
    strokeIcon: true,
    redLabel: false,
  },
  // {
  //   path: ROUTERS_PATHS.EMAIL_TEMPLATE,
  //   subPath: [],
  //   label: 'Email template',
  //   Icon: Icons.AnalyticsIcon,
  //   strokeIcon: true,
  //   redLabel: false
  // },
    {
    path: ROUTERS_PATHS.ADVANCED_SEARCH,
    subPath: [],
    label: "Advanced search",
    Icon: Icons.SearchIconDefault,
    strokeIcon: false,
    redLabel: false,
  },
  {
    path: ROUTERS_PATHS.FEEDBACK,
    subPath: [],
    label: "Feedback",
    Icon: Icons.NewFeedbackIcon,
    strokeIcon: false,
    redLabel: false,
  },
  {
    path: ROUTERS_PATHS.REVIEW,
    subPath: [ROUTERS_PATHS.EDIT_REVIEW],
    label: "Reviews",
    Icon: Icons.ReviewIcon,
    strokeIcon: false,
    redLabel: false,
  },
  {
    path: ROUTERS_PATHS.USER,
    subPath: [],
    label: "Users",
    Icon: Icons.User2Icon,
    strokeIcon: false,
    redLabel: false,
  },

  {
    path: ROUTERS_PATHS.ANALYTICS,
    subPath: [],
    label: "Analytics",
    Icon: Icons.AnalyticsIcon,
    strokeIcon: false,
    redLabel: false,
  },
  // {
  //   path: ROUTERS_PATHS.ROLE,
  //   subPath: [],
  //   label: 'Role',
  //   Icon: Icons.RoleIcon,
  //   strokeIcon: true,
  //   redLabel: false
  // },
];

export default MenuItems;
